import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

/*eslint-disable */
import cacheLs from "../cacheLs";

cacheLs.CURRENT_USER_ID = cacheLs.get_current_user_id_ls();

const state = {
  applicationStaticConfig: cacheLs.get_application_static_config(),
  activeMicroApp: cacheLs.get_active_microapp(),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
